var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    {
      directives: [
        {
          name: "scroll",
          rawName: "v-scroll",
          value: _vm.onScroll,
          expression: "onScroll",
        },
      ],
    },
    [
      _c("mini-header", {
        attrs: {
          title: "Información del punto de venta",
          breadcrumbs: _vm.breadcrumbs,
          dense: true,
          hiddenTab: true,
          addPadding: true,
          scroll: _vm.scroll,
        },
        scopedSlots: _vm._u([
          {
            key: "main",
            fn: function () {
              return undefined
            },
            proxy: true,
          },
        ]),
      }),
      _vm.$store.state.branches.retrieveLoader || _vm.loadingPos
        ? _c("VSkeleton")
        : [
            _c(
              "v-col",
              { staticClass: "px-0", staticStyle: { "z-index": "0" } },
              [
                _c("div", { staticClass: "d-flex" }, [
                  _c(
                    "div",
                    {
                      staticClass: "mr-6",
                      staticStyle: { "min-width": "400px" },
                    },
                    [
                      _c(
                        "v-card",
                        {
                          staticClass: "pa-0",
                          staticStyle: { position: "fixed!important" },
                          attrs: {
                            width: "400",
                            transition: "slide-y-transition",
                            "min-height": "calc(100% - 150px)",
                            flat: "",
                          },
                        },
                        [
                          _c("VCardMapDetail", {
                            attrs: {
                              carouselList: ["", _vm.instance.photo],
                              itemList: _vm.cardMapDetail,
                              hiddenEdit: true,
                            },
                            on: {
                              isClick: function ($event) {
                                _vm.dialogAXPOS = true
                              },
                              handleModal: _vm.handleEditConfigPos,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "pb-5",
                      staticStyle: { flex: "1", "min-width": "180px" },
                    },
                    [
                      _c(
                        "v-card",
                        { staticClass: "d-none", attrs: { flat: "" } },
                        [
                          _c(
                            "v-card-text",
                            { staticClass: "pa-0" },
                            [
                              _c(
                                "v-row",
                                {
                                  attrs: {
                                    justify: "center",
                                    "no-gutters": "",
                                  },
                                },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center px-0 py-10",
                                      attrs: { cols: "4" },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "font-weight-bold subtitle-2 grey-700--text",
                                        },
                                        [_vm._v("Estado")]
                                      ),
                                      _c(
                                        "v-sheet",
                                        {
                                          staticClass:
                                            "d-flex align-center justify-center transparent mt-8",
                                        },
                                        [
                                          _c(
                                            "div",
                                            [
                                              _c(
                                                "v-chip",
                                                {
                                                  staticClass:
                                                    "font-weight-semibold",
                                                  attrs: {
                                                    color: "lightBlue",
                                                    small: "",
                                                    label: "",
                                                  },
                                                },
                                                [
                                                  _vm._v("Activo"),
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      attrs: {
                                                        right: "",
                                                        size: "18",
                                                      },
                                                    },
                                                    [_vm._v("mdi-cloud")]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "mt-2 d-block grey-500--text body-1",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("dateTime")(
                                                        _vm.editable.created
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c("v-divider", { attrs: { vertical: "" } }),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center py-10 pa-0",
                                      attrs: { cols: "4" },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "font-weight-bold subtitle-2 grey-700--text mx-auto",
                                        },
                                        [_vm._v("Cantidad de DTEs")]
                                      ),
                                      _c("div", { staticClass: "mt-9" }, [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "d-block grey-500--text subtitle-2 font-weight-semibold",
                                          },
                                          [_vm._v("13.267")]
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "d-block grey-700--text subtitle-2 mt-2",
                                          },
                                          [_vm._v("Hoy")]
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _c("v-divider", { attrs: { vertical: "" } }),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center py-10 px-0",
                                      attrs: { cols: "4" },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "font-weight-bold subtitle-2 grey-700--text mx-auto",
                                        },
                                        [_vm._v("Total vendido")]
                                      ),
                                      _c("div", { staticClass: "mt-9" }, [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "d-block grey-500--text subtitle-2 font-weight-semibold",
                                          },
                                          [
                                            _vm._v("$757.953 "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "grey-300--text caption",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t("generals.CLP"))
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "d-block grey-700--text subtitle-2 mt-2",
                                          },
                                          [_vm._v("Hoy")]
                                        ),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm.showMoreStatistics
                                ? [
                                    _c("v-divider"),
                                    _c(
                                      "v-row",
                                      {
                                        staticClass: "ma-0",
                                        attrs: {
                                          justify: "center",
                                          "no-gutters": "",
                                        },
                                      },
                                      [
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "text-center py-10",
                                            attrs: { cols: "4" },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "font-weight-bold subtitle-2 grey-700--text mx-auto",
                                              },
                                              [_vm._v("Ticket promedio")]
                                            ),
                                            _c(
                                              "v-sheet",
                                              {
                                                staticClass:
                                                  "d-flex align-center justify-center transparent",
                                                attrs: {
                                                  height: "100",
                                                  "min-width": "100",
                                                },
                                              },
                                              [
                                                _c("div", [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "d-block mt-6 grey-500--text subtitle-2 font-weight-semibold",
                                                    },
                                                    [_vm._v("$45.990")]
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "d-block grey-700--text subtitle-2 mt-3",
                                                    },
                                                    [_vm._v("Últimos 7 días")]
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c("v-divider", {
                                          attrs: { vertical: "" },
                                        }),
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "text-center py-10",
                                            attrs: { cols: "4" },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "font-weight-bold subtitle-2 grey-700--text mx-auto",
                                              },
                                              [_vm._v("Cantidad de DTEs")]
                                            ),
                                            _c(
                                              "v-sheet",
                                              {
                                                staticClass:
                                                  "d-flex align-center justify-center transparent",
                                                attrs: {
                                                  height: "100",
                                                  "min-width": "100",
                                                },
                                              },
                                              [
                                                _c("div", [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "d-block mt-6 grey-500--text subtitle-2 font-weight-semibold",
                                                    },
                                                    [_vm._v("145.736")]
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "d-block grey-700--text subtitle-2 mt-3",
                                                    },
                                                    [_vm._v("Últimos 7 días")]
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c("v-divider", {
                                          attrs: { vertical: "" },
                                        }),
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "text-center py-10",
                                            attrs: { cols: "4" },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "font-weight-bold subtitle-2 grey-700--text mx-auto",
                                              },
                                              [_vm._v("Total vendido")]
                                            ),
                                            _c(
                                              "v-sheet",
                                              {
                                                staticClass:
                                                  "d-flex align-center justify-center transparent",
                                                attrs: {
                                                  height: "100",
                                                  "min-width": "100",
                                                },
                                              },
                                              [
                                                _c("div", [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "d-block mt-6 grey-500--text subtitle-2 font-weight-semibold",
                                                    },
                                                    [
                                                      _vm._v("$ 5.305.671"),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "grey-300--text caption",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "generals.CLP"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "d-block grey-700--text subtitle-2 mt-3",
                                                    },
                                                    [_vm._v("Últimos 7 días")]
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          ),
                          _c("v-divider"),
                          _c(
                            "v-card-actions",
                            { staticClass: "pa-0" },
                            [
                              _c(
                                "v-col",
                                { staticClass: "text-center py-2" },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { outlined: "", ripple: false },
                                      on: {
                                        click: function ($event) {
                                          _vm.showMoreStatistics =
                                            !_vm.showMoreStatistics
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          !_vm.showMoreStatistics
                                            ? "Ver más estadísticas"
                                            : "Ver menos estadísticas"
                                        ) + " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-expansion-panels",
                        {
                          staticClass: "mt-5 d-none",
                          model: {
                            value: _vm.panelPos,
                            callback: function ($$v) {
                              _vm.panelPos = $$v
                            },
                            expression: "panelPos",
                          },
                        },
                        [
                          _c(
                            "v-expansion-panel",
                            [
                              _c(
                                "v-expansion-panel-header",
                                { staticClass: "px-5 py-3" },
                                [
                                  _c(
                                    "v-row",
                                    {
                                      attrs: {
                                        "no-gutters": "",
                                        align: "center",
                                        justify: "space-between",
                                      },
                                    },
                                    [
                                      _c("v-col", { staticClass: "pa-0" }, [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "ml-n1 subtitle-2 grey-700--text font-weight-bold",
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                attrs: {
                                                  size: "18",
                                                  left: "",
                                                  color: "grey-700",
                                                },
                                              },
                                              [_vm._v("mdi-printer-pos")]
                                            ),
                                            _vm._v("Configuración POS"),
                                          ],
                                          1
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-expansion-panel-content",
                                { staticClass: "px-5" },
                                [
                                  _c(
                                    "v-list",
                                    {
                                      staticClass:
                                        "transparent v-list-form px-0",
                                    },
                                    [
                                      _c(
                                        "v-list-item",
                                        { staticClass: "my-2" },
                                        [
                                          _c(
                                            "v-list-item-title",
                                            { staticClass: "subtitle-2" },
                                            [_vm._v("Última señal de vida")]
                                          ),
                                          _c(
                                            "v-list-item-subtitle",
                                            { staticClass: "pl-1" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("dateTime")(
                                                    _vm.instance.created
                                                  )
                                                ) + " "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-list-item",
                                        [
                                          _c(
                                            "v-list-item-title",
                                            { staticClass: "subtitle-2" },
                                            [_vm._v("Instalado el")]
                                          ),
                                          _c(
                                            "v-list-item-subtitle",
                                            { staticClass: "pl-1" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("dateTime")(
                                                    _vm.instance.created
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-list-item",
                                        { staticClass: "my-2" },
                                        [
                                          _c(
                                            "v-list-item-title",
                                            { staticClass: "subtitle-2" },
                                            [_vm._v("Versión de AX-POS")]
                                          ),
                                          _c(
                                            "v-list-item-subtitle",
                                            { staticClass: "pl-1" },
                                            [_vm._v("v0.9")]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-list-item",
                                        [
                                          _c(
                                            "v-list-item-title",
                                            { staticClass: "subtitle-2" },
                                            [
                                              _vm._v(
                                                "Versión del filtro AX-POS"
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "v-list-item-subtitle",
                                            { staticClass: "pl-1" },
                                            [
                                              _vm._v(" v0.1 "),
                                              _c(
                                                "v-btn",
                                                {
                                                  staticClass:
                                                    "ml-2 mt-n1 body-1",
                                                  attrs: {
                                                    color: "grey-900",
                                                    text: "",
                                                    ripple: false,
                                                  },
                                                },
                                                [
                                                  _vm._v("Actualizar"),
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      attrs: {
                                                        color: "grey-900",
                                                        right: "",
                                                      },
                                                    },
                                                    [_vm._v("mdi-autorenew")]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-list-item",
                                        { staticClass: "my-2" },
                                        [
                                          _c(
                                            "v-list-item-title",
                                            { staticClass: "subtitle-2" },
                                            [_vm._v("HMAC")]
                                          ),
                                          _c(
                                            "v-list-item-subtitle",
                                            { staticClass: "pl-1" },
                                            [
                                              _c(
                                                "v-tooltip",
                                                {
                                                  attrs: {
                                                    color: "grey-background",
                                                    right: "",
                                                    transition:
                                                      "scale-transition",
                                                  },
                                                  scopedSlots: _vm._u([
                                                    {
                                                      key: "activator",
                                                      fn: function ({ on }) {
                                                        return [
                                                          _c(
                                                            "v-btn",
                                                            _vm._g(
                                                              {
                                                                staticStyle: {
                                                                  "justify-content":
                                                                    "left",
                                                                },
                                                                attrs: {
                                                                  text: "",
                                                                  color:
                                                                    "grey-700",
                                                                  ripple: false,
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.toClipboard(
                                                                        _vm
                                                                          .instance
                                                                          .hmac ||
                                                                          ""
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              on
                                                            ),
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.instance
                                                                    .hmac || ""
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ]),
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "d-block px-3 py-2",
                                                    },
                                                    [_vm._v("Copiar")]
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-list-item",
                                        [
                                          _c(
                                            "v-list-item-title",
                                            { staticClass: "subtitle-2" },
                                            [
                                              _vm._v(
                                                "Modo de asignación de " +
                                                  _vm._s(
                                                    _vm.$t("generals.folios")
                                                  )
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "v-list-item-subtitle",
                                            { staticClass: "pl-1" },
                                            [_vm._v("Dinámico")]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-list-item",
                                        { staticClass: "my-2" },
                                        [
                                          _c(
                                            "v-list-item-title",
                                            { staticClass: "subtitle-2" },
                                            [_vm._v("Modo de almacenamiento")]
                                          ),
                                          _c(
                                            "v-list-item-subtitle",
                                            { staticClass: "pl-1" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.instance.store_scheme ||
                                                    "-"
                                                )
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-list-item",
                                        { staticClass: "my-2" },
                                        [
                                          _c(
                                            "v-list-item-title",
                                            { staticClass: "subtitle-2" },
                                            [_vm._v("Copias PDF")]
                                          ),
                                          _c(
                                            "v-list-item-subtitle",
                                            { staticClass: "pl-1" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.instance.pdf_copies || "-"
                                                )
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-list-item",
                                        { staticClass: "my-2" },
                                        [
                                          _c(
                                            "v-list-item-title",
                                            { staticClass: "subtitle-2" },
                                            [_vm._v("Forma de envío")]
                                          ),
                                          _c(
                                            "v-list-item-subtitle",
                                            { staticClass: "pl-1" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.instance.sending_way ||
                                                    "-"
                                                )
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-list-item",
                                        { staticClass: "my-2" },
                                        [
                                          _c(
                                            "v-list-item-title",
                                            { staticClass: "subtitle-2" },
                                            [
                                              _vm._v(
                                                "Ruta de almacenamiento XML"
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "v-list-item-subtitle",
                                            { staticClass: "pl-1" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.instance.store_path || "-"
                                                )
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-list-item",
                                        { staticClass: "my-2" },
                                        [
                                          _c(
                                            "v-list-item-title",
                                            { staticClass: "subtitle-2" },
                                            [
                                              _vm._v(
                                                "Ruta de almacenamiento PDF"
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "v-list-item-subtitle",
                                            { staticClass: "pl-1" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.instance.irs_store_path ||
                                                    "-"
                                                )
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-expansion-panels",
                        {
                          model: {
                            value: _vm.panelDocuments,
                            callback: function ($$v) {
                              _vm.panelDocuments = $$v
                            },
                            expression: "panelDocuments",
                          },
                        },
                        [
                          _c(
                            "v-expansion-panel",
                            [
                              _c(
                                "v-expansion-panel-header",
                                { staticClass: "px-4 py-3" },
                                [
                                  _c(
                                    "v-row",
                                    {
                                      attrs: {
                                        "no-gutters": "",
                                        align: "center",
                                        justify: "space-between",
                                      },
                                    },
                                    [
                                      _c("v-col", [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "subtitle-2 grey-700--text font-weight-bold",
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                attrs: {
                                                  size: "18",
                                                  left: "",
                                                  color: "grey-700",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "mdi-file-document-multiple"
                                                ),
                                              ]
                                            ),
                                            _vm._v("Documentos emitidos"),
                                          ],
                                          1
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-expansion-panel-content",
                                { staticClass: "px-0" },
                                [
                                  _c("v-divider"),
                                  _c("documents-list", {
                                    attrs: { showPagination: false },
                                  }),
                                  _vm.count && !_vm.loading
                                    ? [
                                        _c("v-divider"),
                                        _c(
                                          "v-row",
                                          {
                                            staticClass: "px-4 py-4",
                                            attrs: { align: "center" },
                                          },
                                          [
                                            _c(
                                              "v-btn",
                                              {
                                                staticClass: "ml-5 body-1",
                                                attrs: {
                                                  to: {
                                                    name: "DocumentsList",
                                                    params: _vm.currentParams,
                                                    query: {
                                                      cpos_id:
                                                        _vm.$route.params.id,
                                                    },
                                                  },
                                                  ripple: false,
                                                  text: "",
                                                  color: "grey-900",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "Ver todos los documentos"
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            ),
          ],
      _c(
        "v-dialog",
        {
          attrs: {
            width: "700",
            persistent: "",
            "no-click-animation": "",
            scrollable: "",
            "overlay-color": "grey-500",
          },
          model: {
            value: _vm.dialogConfigPos,
            callback: function ($$v) {
              _vm.dialogConfigPos = $$v
            },
            expression: "dialogConfigPos",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "pa-0" },
                [
                  _c(
                    "v-toolbar",
                    {
                      staticClass: "transparent",
                      attrs: { flat: "", height: "46" },
                    },
                    [
                      _c(
                        "v-toolbar-title",
                        {
                          staticClass:
                            "text--grey-700 subtitle-1 font-weight-medium",
                        },
                        [_vm._v("Editar configuración POS")]
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-toolbar-items",
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "mr-3",
                              attrs: { align: "center", justify: "center" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: { icon: "", small: "" },
                                  on: {
                                    click: function ($event) {
                                      _vm.dialogConfigPos = false
                                    },
                                  },
                                },
                                [
                                  _c("v-icon", { attrs: { size: "24" } }, [
                                    _vm._v("mdi-close"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                { staticClass: "pa-0" },
                [
                  _c(
                    "v-list",
                    { staticClass: "v-list-form py-6 transparent" },
                    [
                      _c(
                        "v-list-item",
                        { staticClass: "py-1" },
                        [
                          _c("v-list-item-title", [
                            _vm._v(
                              "Modo de asignación de " +
                                _vm._s(_vm.$t("generals.folios"))
                            ),
                          ]),
                          _c(
                            "v-list-item-subtitle",
                            [
                              _c(
                                "v-radio-group",
                                {
                                  staticClass: "mx-0 mt-n4",
                                  staticStyle: { position: "absolute" },
                                  attrs: {
                                    row: "",
                                    absolute: "",
                                    dense: "",
                                    "hide-details": "",
                                  },
                                  model: {
                                    value: _vm.row,
                                    callback: function ($$v) {
                                      _vm.row = $$v
                                    },
                                    expression: "row",
                                  },
                                },
                                [
                                  _c("v-radio", {
                                    attrs: {
                                      label: "Lineal",
                                      value: "radio-1",
                                    },
                                  }),
                                  _c("v-radio", {
                                    attrs: {
                                      label: "Dinámico",
                                      value: "radio-2",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-list-item",
                        { staticClass: "py-1" },
                        [
                          _c("v-list-item-title", [
                            _vm._v("Modo de almacenamiento"),
                          ]),
                          _c(
                            "v-list-item-subtitle",
                            [
                              _c(
                                "v-radio-group",
                                {
                                  staticClass: "mx-0 mt-n4",
                                  staticStyle: { position: "absolute" },
                                  attrs: {
                                    row: "",
                                    absolute: "",
                                    dense: "",
                                    "hide-details": "",
                                  },
                                  model: {
                                    value: _vm.$v.editable.store_scheme.$mode,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.$v.editable.store_scheme,
                                        "$mode",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "$v.editable.store_scheme.$mode",
                                  },
                                },
                                [
                                  _c("v-radio", {
                                    attrs: {
                                      label: "Base de datos",
                                      value: "radio-1",
                                    },
                                  }),
                                  _c("v-radio", {
                                    attrs: {
                                      label: "Directorio",
                                      value: "radio-2",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-list-item",
                        { staticClass: "py-1" },
                        [
                          _c("v-list-item-title", [_vm._v("Copias PDF")]),
                          _c(
                            "v-list-item-subtitle",
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "8" } },
                                [
                                  _c("v-select", {
                                    attrs: {
                                      error: _vm.$v.editable.pdf_copies.$error,
                                      items: _vm.pdfcopiesList,
                                      "item-text": "name",
                                      "item-value": "id",
                                      "single-line": "",
                                      "hide-details": "",
                                      dense: "",
                                      height: "30",
                                      outlined: "",
                                    },
                                    model: {
                                      value: _vm.$v.editable.pdf_copies.$model,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.$v.editable.pdf_copies,
                                          "$model",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "$v.editable.pdf_copies.$model",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-list-item",
                        { staticClass: "mt-2" },
                        [
                          _c("v-list-item-title", [_vm._v("Forma de envío")]),
                          _c(
                            "v-list-item-subtitle",
                            { staticClass: "py-1" },
                            [
                              _c(
                                "v-radio-group",
                                {
                                  staticClass: "mx-0 mt-n4",
                                  staticStyle: { position: "absolute" },
                                  attrs: {
                                    row: "",
                                    absolute: "",
                                    dense: "",
                                    "hide-details": "",
                                  },
                                  model: {
                                    value: _vm.editable.sending_way,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.editable, "sending_way", $$v)
                                    },
                                    expression: "editable.sending_way",
                                  },
                                },
                                [
                                  _c("v-radio", {
                                    attrs: { label: "XML", value: "radio-1" },
                                  }),
                                  _c("v-radio", {
                                    attrs: { label: "ZIP", value: "radio-2" },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-list-item",
                        [
                          _c("v-list-item-title", [
                            _vm._v("Ruta de almacenamiento XML"),
                          ]),
                          _c(
                            "v-list-item-subtitle",
                            { staticClass: "py-1" },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  error: _vm.$v.editable.store_path.$error,
                                  outlined: "",
                                  required: "",
                                  "single-line": "",
                                  dense: "",
                                  maxlength: "64",
                                  "hide-details": "",
                                },
                                model: {
                                  value: _vm.$v.editable.store_path.$model,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.$v.editable.store_path,
                                      "$model",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "$v.editable.store_path.$model",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-list-item",
                        [
                          _c("v-list-item-title", [
                            _vm._v("Ruta de almacenamiento PDF"),
                          ]),
                          _c(
                            "v-list-item-subtitle",
                            { staticClass: "py-1" },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  error: _vm.$v.editable.irs_store_path.$error,
                                  outlined: "",
                                  required: "",
                                  "single-line": "",
                                  dense: "",
                                  maxlength: "64",
                                  "hide-details": "",
                                },
                                model: {
                                  value: _vm.$v.editable.irs_store_path.$model,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.$v.editable.irs_store_path,
                                      "$model",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression:
                                    "$v.editable.irs_store_path.$model",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "px-5 py-2" },
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { outlined: "" },
                      on: {
                        click: function ($event) {
                          _vm.dialogConfigPos = false
                        },
                      },
                    },
                    [_vm._v("Cancelar")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "grey-900" },
                      on: { click: _vm.setConfigPos },
                    },
                    [_vm._v("Guardar")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            width: "480",
            persistent: "",
            "no-click-animation": "",
            scrollable: "",
            "overlay-color": "grey-500",
          },
          model: {
            value: _vm.dialogAXPOS,
            callback: function ($$v) {
              _vm.dialogAXPOS = $$v
            },
            expression: "dialogAXPOS",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "pa-0" },
                [
                  _c(
                    "v-toolbar",
                    {
                      staticClass: "transparent",
                      attrs: { flat: "", height: "46" },
                    },
                    [
                      _c(
                        "v-toolbar-title",
                        {
                          staticClass:
                            "px-5 subtitle-2 grey-500--text font-weight-semibold",
                        },
                        [_vm._v("AX-PoS")]
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-toolbar-items",
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "mr-3",
                              attrs: { align: "center", justify: "center" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "ml-3",
                                  attrs: {
                                    icon: "",
                                    small: "",
                                    "retain-focus-on-click": "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.dialogAXPOS = false
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: { color: "grey-500", size: "20" },
                                    },
                                    [_vm._v("mdi-close")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                { staticClass: "pt-0 pb-2" },
                [
                  _c(
                    "v-list",
                    { staticClass: "v-list-form-2 transparent" },
                    [
                      _c(
                        "v-list-item",
                        [
                          _c("v-list-item-title", [_vm._v("MAC Address")]),
                          _c("v-list-item-subtitle", [
                            _vm.axPosDetail?.mac_address
                              ? _c("span", [
                                  _vm._v(_vm._s(_vm.axPosDetail?.mac_address)),
                                ])
                              : _c(
                                  "span",
                                  {
                                    staticClass:
                                      "body-2 text--disabled font-italic",
                                  },
                                  [_vm._v("Sin especificar")]
                                ),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "v-list-item",
                        { staticClass: "py-1" },
                        [
                          _c("v-list-item-title", [_vm._v("Estado")]),
                          _c("v-list-item-subtitle", { staticClass: "py-1" }, [
                            _vm.axPosDetail?.mac_address
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.axPosDetail?.active
                                        ? "Activo"
                                        : "Inactivo"
                                    )
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "v-list-item",
                        [
                          _c("v-list-item-title", [
                            _vm._v("Fecha de creación"),
                          ]),
                          _c("v-list-item-subtitle", { staticClass: "py-1" }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("dateTimeSecond")(
                                  _vm.axPosDetail?.created
                                )
                              )
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "v-list-item",
                        { staticClass: "py-1" },
                        [
                          _c("v-list-item-title", [
                            _vm._v("Asociar configuración"),
                          ]),
                          _c(
                            "v-list-item-subtitle",
                            { staticClass: "py-1" },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  items: _vm.configList,
                                  "item-value": "id",
                                  "item-text": "name",
                                  "append-icon": "mdi-chevron-down",
                                  "menu-props": {
                                    overflowY: true,
                                    transition: "slide-y-transition",
                                  },
                                  height: "30",
                                  "single-line": "",
                                  outlined: "",
                                  dense: "",
                                  "hide-details": "",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "item",
                                    fn: function (data) {
                                      return [
                                        _c(
                                          "v-list-item-title",
                                          {
                                            staticClass: "font-weight-regular",
                                          },
                                          [_vm._v(_vm._s(data.item.name))]
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                                model: {
                                  value: _vm.newConfig,
                                  callback: function ($$v) {
                                    _vm.newConfig = $$v
                                  },
                                  expression: "newConfig",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-list-item",
                        [
                          _c("v-list-item-title", [
                            _vm._v("Versión de software"),
                          ]),
                          _c(
                            "v-list-item-subtitle",
                            { staticClass: "py-1" },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  outlined: "",
                                  required: "",
                                  "single-line": "",
                                  dense: "",
                                  maxlength: "100",
                                  "hide-details": "",
                                },
                                model: {
                                  value: _vm.swVersion,
                                  callback: function ($$v) {
                                    _vm.swVersion = $$v
                                  },
                                  expression: "swVersion",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-list-item",
                        { staticClass: "py-1" },
                        [
                          _c("v-list-item-title", [_vm._v("Certificado")]),
                          _c(
                            "v-list-item-subtitle",
                            { staticClass: "py-1" },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  items: _vm.certificatesList,
                                  "item-value": "digest",
                                  "append-icon": "mdi-chevron-down",
                                  "item-text": "name",
                                  "menu-props": {
                                    overflowY: true,
                                    transition: "slide-y-transition",
                                  },
                                  height: "30",
                                  "single-line": "",
                                  outlined: "",
                                  dense: "",
                                  "hide-details": "",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "item",
                                    fn: function (data) {
                                      return [
                                        _c(
                                          "v-list-item-title",
                                          {
                                            staticClass: "font-weight-regular",
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "d-block" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("date")(
                                                      data.item.date_start
                                                    )
                                                  ) +
                                                    " - " +
                                                    _vm._s(
                                                      _vm._f("date")(
                                                        data.item.date_end
                                                      )
                                                    )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "selection",
                                    fn: function (data) {
                                      return [
                                        _c(
                                          "v-list-item-title",
                                          {
                                            staticClass: "font-weight-regular",
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "d-block" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("date")(
                                                      data.item.date_start
                                                    )
                                                  ) +
                                                    " - " +
                                                    _vm._s(
                                                      _vm._f("date")(
                                                        data.item.date_end
                                                      )
                                                    )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                                model: {
                                  value: _vm.certificate,
                                  callback: function ($$v) {
                                    _vm.certificate = $$v
                                  },
                                  expression: "certificate",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "span",
                    {
                      staticClass:
                        "subtitle-2 grey-500--text font-weight-medium",
                    },
                    [_vm._v("Listado de POS")]
                  ),
                  _c(
                    "v-col",
                    { staticClass: "px-0" },
                    [
                      _c(
                        "v-card",
                        {
                          staticClass: "px-0",
                          attrs: { flat: "", outlined: "" },
                        },
                        [
                          _c("v-simple-table", {
                            staticClass: "px-0 no-hover table-not-rounded",
                            attrs: { dense: "" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function () {
                                  return [
                                    _c(
                                      "thead",
                                      [
                                        _c("tr", [
                                          _c(
                                            "th",
                                            {
                                              staticClass:
                                                "text-left grey-700--text font-weight-medium",
                                              staticStyle: {
                                                "min-width": "180px",
                                              },
                                            },
                                            [_vm._v("POS")]
                                          ),
                                          _c(
                                            "th",
                                            {
                                              staticClass:
                                                "text-left grey-700--text font-weight-medium",
                                              staticStyle: {
                                                "min-width": "120px",
                                              },
                                            },
                                            [_vm._v("ID")]
                                          ),
                                          _c(
                                            "th",
                                            {
                                              staticClass:
                                                "text-left grey-700--text font-weight-medium",
                                              staticStyle: {
                                                "min-width": "70px",
                                              },
                                            },
                                            [_vm._v("Estado")]
                                          ),
                                        ]),
                                        _c("v-divider", {
                                          staticStyle: {
                                            position: "absolute",
                                            "margin-top": "-10px",
                                            "min-width": "100%",
                                            "margin-left": "-1px",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "tbody",
                                      _vm._l(_vm.axPOSList, function (item) {
                                        return _c("tr", { key: item.id }, [
                                          _c("td", { staticClass: "body-2" }, [
                                            item.name
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "d-inline-block text-truncate ml-n1",
                                                    staticStyle: {
                                                      "max-width": "99%",
                                                    },
                                                  },
                                                  [_vm._v(_vm._s(item.name))]
                                                )
                                              : _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "body-2 text--disabled font-italic",
                                                  },
                                                  [_vm._v("Sin especificar")]
                                                ),
                                          ]),
                                          _c(
                                            "td",
                                            {
                                              staticClass: "text-left body-2",
                                              staticStyle: {
                                                "min-width": "180px",
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "d-inline-block text-truncate",
                                                  staticStyle: {
                                                    "max-width": "99%",
                                                  },
                                                },
                                                [_vm._v(_vm._s(item.cpos_id))]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "td",
                                            { staticClass: "text-left" },
                                            [
                                              item
                                                ? _c(
                                                    "v-chip",
                                                    {
                                                      attrs: {
                                                        color: item.active
                                                          ? "blue-100"
                                                          : "",
                                                        "text-color":
                                                          item.active
                                                            ? "blue-500"
                                                            : "",
                                                        small: "",
                                                        label: "",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.active
                                                            ? "Activo"
                                                            : "Inactivo"
                                                        )
                                                      ),
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: {
                                                            right: "",
                                                            size: "18",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "mdi-cloud" +
                                                              _vm._s(
                                                                item.active
                                                                  ? ""
                                                                  : "-off"
                                                              )
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                        ])
                                      }),
                                      0
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "px-5 py-2" },
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { outlined: "" },
                      on: {
                        click: function ($event) {
                          _vm.dialogAXPOS = false
                        },
                      },
                    },
                    [_vm._v("Cancelar")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "grey-900",
                        loading: _vm.loadingAssignConfig,
                      },
                      on: { click: _vm.assignConf },
                    },
                    [_vm._v("Guardar")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }